module.exports = __webpack_public_path__ + "static/media/vert.5c920a9c.png";